export namespace FlightAvailabilityNS {
  export interface FlightAvailabilityRequest {
    origin: string;
    destination: string;
    departureTime: string;
    preDateFlexibility: number;
    postDateFlexibility: number;
    numberOfSeats: number;
    filterOnlyRedemptionClasses?: boolean;
    minResults: number;
  }

  export interface FlightAvailabilityResponse {
    origin: string;
    destination: string;
    journeyOptionsByDate: JourneyOptionsByDate[];
  }

  export interface JourneyOptionsByDate {
    departureDate: string;
    journeyOptions: JourneyOptions[];
    errorOrWarnings: unknown[];
    moreFlightOptionsAvailable: boolean;
  }

  export const enum PartnerAgreement {
    SKYTEAM = 'SKYTEAM',
    BILATERAL = 'BILATERAL',
  }

  export interface JourneyOptions {
    segments: AvailabilitySegment[];
    partnerAgreement: PartnerAgreement;
    totalDuration: string;
  }

  export interface JourneyOptionsWithUuid extends Omit<JourneyOptions, 'segments'> {
    uuid: string;
    segments: AvailabilitySegmentWithId[];
  }

  export interface DecoratedFlightAvailabilityResponse
    extends Omit<FlightAvailabilityResponse, 'journeyOptionsByDate'> {
    journeyOptionsByDate: PartialJourneyOptionsByDate[];
  }

  export interface PartialJourneyOptionsByDate
    extends Omit<JourneyOptionsByDate, 'journeyOptions' | 'errorOrWarnings' | 'moreFlightOptionsAvailable'> {
    journeyOptions: JourneyOptionsWithUuid[];
  }

  export interface AvailabilitySegment {
    departureTime: string;
    arrivalTime: string;
    departureLocation: string;
    arrivalLocation: string;
    marketingCarrierCode: string;
    marketingCarrierName: string;
    operatingCarrierCode?: string;
    operatingCarrierName?: string;
    operatingCarrierInfo: string[];
    flightNumber: string;
    bookingClasses: BookingClass[];
    typeOfAircraft: string;
    numberOfStops: number;
    departureTerminal: string;
    departureGate: unknown;
    arrivalTerminal?: string;
    arrivalGate: unknown;
    order: number;
    segmentDuration: string;
    layoverDuration?: string;
  }

  export interface AvailabilitySegmentWithId extends AvailabilitySegment {
    id: string;
  }

  export const enum BookingClassCabin {
    ECONOMY = 'ECONOMY',
    PREMIUM_ECONOMY = 'PREMIUM_ECONOMY',
    BUSINESS = 'BUSINESS',
    FIRST_CLASS = 'FIRST_CLASS',
  }

  // From this and Ape build cabins
  export interface BookingClass {
    bookingClass: string;
    seatStatus: string;
    cabin: BookingClassCabin;
    seatsAvailable?: number;
  }
}

export type SegmentBookingClass = {
  economy?: string;
  premium?: string;
  business?: string;
};
